import React, { Component } from 'react';
import { connect } from "react-redux";
import ReactMarkdown from 'react-markdown';

import { Row, Col } from 'reactstrap';

import * as actions from '../../actions/BlogActions';
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import BlogTeaser from "../../components/BlogTeaser/BlogTeaser";
import Spinner from '../../components/Spinner/Spinner';
import styles from '../../components/BlogTeaser/BlogTeaser.css';
import Moment from 'react-moment';

class BlogDetailContainer extends Component {

  componentDidMount() {
    const { loadSingleBlogItem, match } = this.props;

    loadSingleBlogItem(match.params.articleID);
  }

  render() {
    const { currentBlogItem } = this.props;

    if (!currentBlogItem) {
      return (
        <Content>
          <Spinner />
        </Content>
      )
    }

    return (
      <Content>

        <div className={styles.photoHeader}
             style={{ backgroundImage: "url('" + process.env.BLOG_URL + currentBlogItem.thumbnail.url + "')" }}>
          <div className={styles.photoOverlay}>
            <Section>
              <span className={styles.date}>Veröffentlicht am <Moment date={currentBlogItem.created_at}
                                                                      format="DD.MM.YYYY" /></span>
              <Headline className={styles.title}>{currentBlogItem.title}</Headline>
            </Section>
          </div>
        </div>

        <Section>
          <Row>
            <Col sm={8} className={styles.content}>
              <ReactMarkdown source={currentBlogItem.content} />
            </Col>
          </Row>

        </Section>

      </Content>
    )
  }
}

function mapStateToProps(state) {
  return {
    currentBlogItem: state.currentBlogItem,
  };
}

export default connect(mapStateToProps, actions)(BlogDetailContainer);




// WEBPACK FOOTER //
// ./src/container/public/BlogDetailContainer.js